const SCHEDULE_SETTINGS_VERSION = '2';

export const getScheduleSettingsKey = () => `k-scheduleSettings-v${SCHEDULE_SETTINGS_VERSION}`;
export const RECENTLY_USED_WORKING_HOURS = 'k-recentlyUsedWorkingHours';
